import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-be8acd80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fretboard-tooltip-content" }
const _hoisted_2 = { class: "note-info" }
const _hoisted_3 = { class: "note-name" }
const _hoisted_4 = {
  key: 0,
  class: "alternate-name"
}
const _hoisted_5 = {
  key: 0,
  class: "scale-degree"
}
const _hoisted_6 = { class: "degree-value" }
const _hoisted_7 = {
  key: 1,
  class: "instruction"
}


import { getNoteEnharmonicInfo } from "@/utils/noteUtils";

interface TooltipData {
  noteName: string;
  scaleDegree?: string | number;
  instruction?: string;
  fret: number;
  string: number;
}

interface Props {
  data: TooltipData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FretboardTooltipContent',
  props: {
    data: {}
  },
  setup(__props: any) {



function formatScaleDegree(degree: string | number): string {
  if (typeof degree === "number") {
    // Convert 0-based to 1-based and add ordinal suffix
    const oneBasedDegree = degree + 1;
    const suffixes = ["st", "nd", "rd"];
    const suffix = suffixes[oneBasedDegree - 1] || "th";
    return `${oneBasedDegree}${suffix}`;
  }
  return degree.toString();
}

function getAlternateName(noteName: string): string | null {
  // Convert note name to chromatic interval, then get enharmonic info
  // This is a simple mapping - in practice, this would use the interval from the note data
  const noteToInterval: Record<string, number> = {
    C: 0,
    "C#": 1,
    Db: 1,
    D: 2,
    "D#": 3,
    Eb: 3,
    E: 4,
    F: 5,
    "F#": 6,
    Gb: 6,
    G: 7,
    "G#": 8,
    Ab: 8,
    A: 9,
    "A#": 10,
    Bb: 10,
    B: 11,
  };

  const interval = noteToInterval[noteName];
  if (interval === undefined) return null;

  const enharmonicInfo = getNoteEnharmonicInfo(interval);

  // Return the alternate (the one that's not the current primary)
  if (enharmonicInfo.primary === noteName) {
    return enharmonicInfo.alternate;
  } else if (enharmonicInfo.alternate === noteName) {
    return enharmonicInfo.primary;
  }

  return null;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.data.noteName), 1),
      (getAlternateName(_ctx.data.noteName))
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(getAlternateName(_ctx.data.noteName)), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.data.scaleDegree !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(formatScaleDegree(_ctx.data.scaleDegree)), 1),
          _createTextVNode(" scale degree ")
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.instruction)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.data.instruction), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})